import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import fileSize from 'filesize';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useI18n } from '../i18n';
export const FileUpload = ({ onChange, accept, label: _label, helper: _helper, multiple = false, }) => {
    var _a, _b;
    const { $t } = useI18n();
    const { data: network } = useNetwork();
    const hiddenFileInput = useRef();
    const label = _label !== null && _label !== void 0 ? _label : $t({
        id: 'Generics.ChooseAFile',
        defaultMessage: 'Choose a file',
    });
    const helper = _helper !== null && _helper !== void 0 ? _helper : (((_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.fileSizeLimit) &&
        $t({
            id: 'Generics.FileSizeLimit',
            defaultMessage: 'The file size limit is {size_limit}.',
        }, {
            size_limit: fileSize(((_b = network === null || network === void 0 ? void 0 : network.settings) === null || _b === void 0 ? void 0 : _b.fileSizeLimit) || 50000, {
                spacer: '',
            }),
        }));
    const _onChange = useCallback(event => {
        const files = Array.from(event.target.files || []);
        // allow to select same file twice
        event.target.value = '';
        onChange(files);
    }, [onChange]);
    return (_jsxs("div", { className: "flex flex-col items-center justify-center w-96 max-w-full pt-10 mx-auto", children: [_jsx(Button, { onClick: () => {
                    hiddenFileInput.current.click();
                }, children: label }, void 0), _jsx("input", { type: "file", className: "hidden", ref: hiddenFileInput, onChange: _onChange, accept: accept, multiple: multiple, hidden: true }, void 0), _jsx(FormControl.HelperText, { className: "mt-3 text-center", children: helper }, void 0)] }, void 0));
};
//# sourceMappingURL=FileUpload.js.map